import React, { useState } from "react";
import { Modal, Button, Form, Col, Row, Spinner, Alert } from "react-bootstrap";
import AuthHelper from "../../helpers/AuthHelper";
import {
  ENTER_OLD_PASSWORD,
  ENTER_NEW_PASSWORD,
  ENTER_PASSWORD,
  PASSWORD_EIGHT_CHARACTERS,
  PASSWORD_DO_NOT_MATCH,
  NEW_PASSWORD_SHOULD_BE_DIFFERENT,
  RE_ENTER_PASSWORD,
  PASSWORD_UPDATED,
  ENTER_CORRECT_OLD_PASSWORD,
  ERROR_WHILE_ATTEMPTING_CHANGE_PASSWORD,
  ATTEMPT_LIMIT_EXCEEDED,
} from "../../configurations/MessageConstants";
import {
  DANGER,
  EMPTY,
  INVALID_PARAMETER_EXCEPTION,
  LIMIT_EXCEEDED_EXCEPTION,
  NOT_AUTHORIZED_EXCEPTION,
} from "../../configurations/Constants";
function ChangePasswordPopup(props) {
  const [oldPassword, setOldPassword] = useState(EMPTY);
  const [password, setPassword] = useState(EMPTY);
  const [confirmPassword, setConfirmPassword] = useState(EMPTY);
  const [oldPasswordError, setOldPasswordError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [oldPasswordErrorMessage, setOldPasswordErrorMessage] = useState(EMPTY);
  const [passwordErrorMessage, setPasswordErrorMessage] = useState(EMPTY);
  const [confirmPasswordErrorMessage, setConfirmPasswordErrorMessage] =
    useState(EMPTY);
  const [btnChangePassClick, setBtnChangePassClick] = useState(false);
  const [successInfo, setSuccessInfo] = useState(false);
  const [successMessage, setSuccessMessage] = useState(EMPTY);
  const [AuthError, setAuthError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(EMPTY);
  const [showpassword, setShowpassword] = useState(false);

  const resetState = () => {
    setOldPassword(EMPTY);
    setPassword(EMPTY);
    setConfirmPassword(EMPTY);
    setOldPasswordError(false);
    setPasswordError(false);
    setConfirmPasswordError(false);
    setOldPasswordErrorMessage(EMPTY);
    setPasswordErrorMessage(EMPTY);
    setConfirmPasswordErrorMessage(EMPTY);
    setBtnChangePassClick(false);
    setAuthError(false);
    setErrorMessage(EMPTY);
    setShowpassword(false);
  };

  const onValueChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name === "oldPassword") {
      setOldPassword(value);
      if (value === EMPTY) {
        setOldPasswordError(true);
        setOldPasswordErrorMessage(ENTER_OLD_PASSWORD);
      }
    }

    if (name === "password") {
      setPassword(value);
      if (value === EMPTY) {
        setPasswordError(true);
        setPasswordErrorMessage(ENTER_PASSWORD);
      } else if (value.length < 8) {
        setPasswordError(true);
        setPasswordErrorMessage(PASSWORD_EIGHT_CHARACTERS);
        if (confirmPassword.length < 8 || password !== confirmPassword) {
          setConfirmPasswordError(true);
          setConfirmPasswordErrorMessage(PASSWORD_DO_NOT_MATCH);
          setBtnChangePassClick(false);
        }
      } else if (value === oldPassword) {
        setPasswordError(true);
        setPasswordErrorMessage(NEW_PASSWORD_SHOULD_BE_DIFFERENT);
      } else {
        setPasswordError(false);
        setPasswordErrorMessage(EMPTY);
      }
    }
    if (name === "confirmPassword") {
      setConfirmPassword(value);
      if (value === EMPTY) {
        setConfirmPasswordError(true);
        setConfirmPasswordErrorMessage(RE_ENTER_PASSWORD);
      } else if (password !== value) {
        setConfirmPasswordError(true);
        setConfirmPasswordErrorMessage(PASSWORD_DO_NOT_MATCH);
      } else if (password.length < 8) {
        setConfirmPasswordError(true);
        setConfirmPasswordErrorMessage(PASSWORD_DO_NOT_MATCH);
      } else {
        setConfirmPasswordError(false);
        setConfirmPasswordErrorMessage(PASSWORD_DO_NOT_MATCH);
      }
    }
  };

  const changePassword = async (event) => {
    setBtnChangePassClick(true);
    event.preventDefault();
    event.stopPropagation();
    setPasswordError(false);
    setConfirmPasswordError(false);
    setOldPasswordError(false);

    if (oldPassword === EMPTY) {
      setOldPasswordError(true);
      setOldPasswordErrorMessage(ENTER_OLD_PASSWORD);
      setBtnChangePassClick(false);
    }
    if (password === EMPTY) {
      setPasswordError(true);
      setPasswordErrorMessage(ENTER_NEW_PASSWORD);
      setBtnChangePassClick(false);
    }
    if (confirmPassword === EMPTY) {
      setConfirmPasswordError(true);
      setConfirmPasswordErrorMessage(RE_ENTER_PASSWORD);
      setBtnChangePassClick(false);
    }
    if (password !== EMPTY) {
      if (password.length < 8) {
        setPasswordError(true);
        setPasswordErrorMessage(PASSWORD_EIGHT_CHARACTERS);
        setBtnChangePassClick(false);
      }
      if (confirmPassword === EMPTY) {
        setConfirmPasswordError(true);
        setConfirmPasswordErrorMessage(RE_ENTER_PASSWORD);
        setBtnChangePassClick(false);
      } else if (confirmPassword.length < 8 || password !== confirmPassword) {
        setConfirmPasswordError(true);
        setConfirmPasswordErrorMessage(PASSWORD_DO_NOT_MATCH);
        setBtnChangePassClick(false);
        return false;
      }
    }

    if (
      oldPassword === EMPTY ||
      password === EMPTY ||
      confirmPassword === EMPTY
    ) {
      return false;
    }
    if (
      oldPassword !== EMPTY ||
      password !== EMPTY ||
      confirmPassword !== EMPTY
    ) {
      if (password === oldPassword) {
        setPasswordError(true);
        setPasswordErrorMessage(NEW_PASSWORD_SHOULD_BE_DIFFERENT);
        setBtnChangePassClick(false);
        return false;
      }
      if (password !== confirmPassword) {
        setConfirmPasswordError(true);
        setConfirmPasswordErrorMessage(PASSWORD_DO_NOT_MATCH);
        setBtnChangePassClick(false);
        return false;
      }
    }
    try {
      await AuthHelper.changePassword(oldPassword, password);
      setSuccessInfo(true);
      setAuthError(false);
      setSuccessMessage(PASSWORD_UPDATED);
      resetState();

      setTimeout(() => {
        props.closeModal();
        setSuccessInfo(false);
        resetState();
      }, 3000);

      setTimeout(() => {
        resetState();
      }, 3500);
    } catch (error) {
      if (error.response.data.message_code === NOT_AUTHORIZED_EXCEPTION) {
        setErrorMessage(ENTER_CORRECT_OLD_PASSWORD);
        setAuthError(true);
        setBtnChangePassClick(false);
      } else if (
        error.response.data.message_code === INVALID_PARAMETER_EXCEPTION
      ) {
        setErrorMessage(PASSWORD_EIGHT_CHARACTERS);
        setAuthError(true);
        setBtnChangePassClick(false);
      } else if (
        error.response.data.message_code === LIMIT_EXCEEDED_EXCEPTION
      ) {
        setErrorMessage(ATTEMPT_LIMIT_EXCEEDED);
        setAuthError(true);
        setBtnChangePassClick(false);
      } else {
        setErrorMessage(ERROR_WHILE_ATTEMPTING_CHANGE_PASSWORD);
        setAuthError(true);
        setBtnChangePassClick(false);
        return false;
      }
    }
  };

  const toggleShowPassword = () => {
    setShowpassword(!showpassword);
  };

  let closeModal = () => {};
  return (
    <Modal
      show={props.showChangePasswordPopup}
      onHide={closeModal}
      className="confirm-modal"
    >
      <Modal.Header>
        <h3>{"Change Password"}</h3>
      </Modal.Header>
      <Modal.Body>
        {AuthError && (
          <Alert
            variant={DANGER}
            onClose={() => setAuthError(false)}
            dismissible
          >
            {errorMessage}
          </Alert>
        )}
        {successInfo && (
          <Alert
            variant="success"
            onClose={() => setSuccessInfo(false)}
            dismissible
          >
            {successMessage}
          </Alert>
        )}

        <Form noValidate>
          <div>
            <Row className="mb-2">
              <Form.Group as={Col} md="12" controlId="validationOldPassword">
                <Form.Label>Old Password</Form.Label>
                <Form.Control
                  type={showpassword ? "text" : "password"}
                  name="oldPassword"
                  onChange={(e) => {
                    onValueChange(e);
                  }}
                  value={oldPassword || EMPTY}
                  className={
                    oldPasswordError
                      ? "is-invalid invalidcontrol"
                      : oldPassword !== EMPTY
                      ? "is-valid"
                      : EMPTY
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {oldPasswordErrorMessage}
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col} md="12" controlId="validationPassword">
                <Form.Label>New Password</Form.Label>
                <Form.Control
                  type={showpassword ? "text" : "password"}
                  name="password"
                  minLength="8"
                  onChange={(e) => {
                    onValueChange(e);
                  }}
                  value={password || EMPTY}
                  className={
                    passwordError
                      ? "is-invalid invalidcontrol"
                      : password !== EMPTY
                      ? password.length < 8
                        ? "is-invalid invalidcontrol"
                        : "is-valid"
                      : EMPTY
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {passwordErrorMessage}
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col} md="12" controlId="validationConfPassword">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Control
                  type={showpassword ? "text" : "password"}
                  name="confirmPassword"
                  onChange={(e) => {
                    onValueChange(e);
                  }}
                  value={confirmPassword || EMPTY}
                  className={
                    confirmPasswordError
                      ? "is-invalid invalidcontrol"
                      : confirmPassword !== EMPTY
                      ? "is-valid"
                      : confirmPassword !== password
                      ? "is-invalid invalidcontrol"
                      : EMPTY
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {confirmPasswordErrorMessage}
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="12">
                <Form.Check
                  id="showPasswordchangeId"
                  type="checkbox"
                  label="Show Password"
                  onChange={() => {
                    toggleShowPassword();
                  }}
                />
              </Form.Group>
            </Row>
          </div>
          <Button
            disabled={btnChangePassClick}
            type="submit"
            onClick={(e) => changePassword(e)}
          >
            {btnChangePassClick ? (
              <div>
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{" "}
                <span>Changing</span>
              </div>
            ) : (
              "Change Password"
            )}
          </Button>{" "}
          <Button
            type="button"
            onClick={(e) => {
              resetState();
              props.closeModal();
            }}
          >
            Close
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
export default ChangePasswordPopup;
